(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-buy-buttons"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    constructor() {
      super()
      this.inputElement = this.querySelector('input')
      this.#prepareEventHandlers()
    }

    #prepareEventHandlers() {
      const minusButton = this.querySelector('[name="minus"]')
      const plusButton = this.querySelector('[name="plus"]')

      ;[minusButton, plusButton].forEach(button => {
        button.addEventListener('click', this.#onButtonClick)
      })
    }

    #onButtonClick = event => {
      event.preventDefault()
      const currentValue = parseInt(this.inputElement.value)
      const newValue = event.target.name === 'plus' ? currentValue + 1 : currentValue - 1
      this.inputElement.value = newValue > 0 ? newValue : 1
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput)
  }
  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    const { requestState } = event.detail
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      setTimeout(() => {
        const drawer = document.getElementById('cart-drawer')
        if (drawer) drawer.checked = true
      }, 100)
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-quantity-selector"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    constructor() {
      super()
      this.inputElement = this.querySelector('input')
      this.#prepareEventHandlers()
    }

    #prepareEventHandlers() {
      const minusButton = this.querySelector('[name="minus"]')
      const plusButton = this.querySelector('[name="plus"]')

      ;[minusButton, plusButton].forEach(button => {
        button.addEventListener('click', this.#onButtonClick)
      })
    }

    #onButtonClick = event => {
      event.preventDefault()
      const currentValue = parseInt(this.inputElement.value)
      const newValue = event.target.name === 'plus' ? currentValue + 1 : currentValue - 1
      this.inputElement.value = newValue > 0 ? newValue : 1
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput)
  }
  } catch(e) { console.error(e); }
})();

})();
